
define('text!modules/reporting/campaigns/templates/no-data-grid-item.html',[],function () { return '{{#items}}\n<div class="item {{#firstRow}}first{{/firstRow}}">\n  {{#keys}}\n  <div class="column text">--</div>\n  {{/keys}}\n  {{^keys}}\n  <div class="msg {{ blank }}">{{ msg }}</div>\n  {{/keys}}\n</div>\n{{/items}}\n';});

